export function AlertsTab({ alerts, onOpen }) {
  return (
    <div data-testid="alerts-tab" className="space-y-2">
      {alerts.length === 0 && (
        <p data-testid="alerts-empty" className="text-sm text-slate-400 text-center py-10 bg-white rounded-xl border border-slate-200">
          Aucune alerte — tous les dossiers sont à jour.
        </p>
      )}
      {alerts.map((a, i) => (
        <button key={i} data-testid={`alert-row-${i}`} onClick={() => onOpen(a)}
          className="w-full text-left bg-white rounded-xl border border-slate-200 px-5 py-3.5 hover:border-brand-turquoise transition-colors flex items-center gap-3">
          <span className={`text-[10px] font-bold uppercase rounded-full px-2 py-0.5 shrink-0 ${
            a.severity === "haute" ? "bg-red-50 text-red-600" : "bg-amber-50 text-amber-700"}`}>{a.severity}</span>
          <span className="text-sm text-slate-700 flex-1">{a.label}</span>
          <span className="text-xs text-slate-400">{{ employer: "Employeur", candidate: "Candidat", offer: "Offre" }[a.entity_type]}</span>
        </button>
      ))}
    </div>
  );
}
